export const AccountInfoCN = {
    'Account.Menu.Account': '我的账户',
    'Account.Menu.Renew.Subscription': '续订',
    'Account.Menu.Security.Settings': '安全设置',
    'Account.Menu.Email.Address': '邮箱修改',
    'Account.Menu.Password': '密码修改',
    'Account.Menu.Login.log': '登录日志',
    'Account.Module.Username': '用户姓名',
    'Account.Module.First.Name': '名',
    'Account.Module.Phone': '手机',
    'Account.Module.Last.Name': '姓',
    'Account.Module.Institution.Name': '机构名称',
    'Account.Module.Account.Status': '账号状态',
    'Account.Module.Subscribe.Or.Renew': '订阅或续订',
    'Account.Module.Current.Email': '当前邮箱',
    'Account.Module.New.Email': '新建邮箱',
    'Account.Module.Authentication.Code': '验证码',
    'Account.Module.Current.Password': '当前密码',
    'Account.Module.New.Password': '新建密码',
    'Account.Module.Confirm.Password': '确认密码',
    'Account.Module.Last.Records': '最近10条',
    'Account.Module.Subscription.Description': '订阅说明',
    'Account.Log.Time': '时间',
    'Account.Log.Login.ip': '登录ip',
    'Account.Log.Location': '位置',
    'Account.Code': '验证码',

    'Groups.Title':'团队',
    "Group.Create": "创建新团队",
    "Group.Name": "团队名称",
    "Group.ID": "团队ID",
    "Group.Role": "角色",
    'Group.Create.Placeholder': '请输入团队名称',
    'Group.Limit': '席位',
    "Group.Settings": '团队管理',
    "Leave.Btn": '退出',
    'Group.Leave': '退出团队',
    'Group.Leave.Tips1': '请确认退出团队',
    'Group.Leave.Tips2': '操作不可撤销，请谨慎操作',

    'Seat.Settings': '席位管理',
    'Search.Group': '搜索团队',
    "Seat.Label": '席位(已用/上限)',
    'Group.Notes': '备注',
    'Group.Name.Length.Error': '团队名称长度不能超过16个字符',
    'My.Space': '我的空间',
    'Seat.User': '用户',
    'Seat.Permission': '权限',
    'Seat.Invite.New.Member': '邀请新成员',
    'Seat.Invite.Link': '邀请链接',
    'Seat.Invite.Link.Btn': '复制链接',
    'Seat.Invite.Valid.Link.Tips': '链接有效期为10天，且仅可使用一次',
    'Seat.Invite.Link.Copy.Success': '邀请链接复制成功',
    'Seat.Invite.Link.Copy.Failed': '邀请链接复制失败，请重试',

    'Invite.Member.Tips1': '您已收到邀请',
    'Invite.Member.Tips2': '邀请您加入',
    'Invite.Member.Tips3': '加入团队后，您可以有',
    'Invite.Member.Tips4': '共享项目。',
    'Invite.Member.Btn1': "暂不加入",
    'Invite.Member.Btn2': "加入团队",
    "Invite.Successful.Header": "加入团队成功",
    "Invite.Successful.Content": "您已成功加入",
    "Invite.Successful.Content1": "团队。",
    "Invite.Successful.Content2": "您可以通过主菜单中的项目下拉菜单查看团队。",

    'Space.Integrated.Datasets': '云项目',
    'Space.Uploaded.Files': '上传文件',
    'Space.Custom.Datasets': '本地项目',
    'Space.Project.Files': '项目文件',
    'Space.Other.Projects': '其他项目(拥有者)',
    'Space.Free': '空闲(拥有者)',
    'Space.Total': '总计',
    'Leave.Group.Tips': '团队拥有者不可退出团队',
    'Edit.Group.Tips': '仅团队拥有者可以操作',
    'Merge.Group.Tips': '仅团队拥有者可以操作',
    'Transfer.Group.Tips': '仅团队拥有者可以操作',

    'Leave.Seatting.Tips': '拥有者角色不可退出团队',
    'Leave.Tips': '没有权限操作',
    'Role.tips1': 'Owner：团队拥有者, 可以操作团队管理页面',
    'Role.tips2': 'Admin：团队管理员, 可以操作团队管理页面',
    'Role.tips3': 'Member：团队成员, 不可操作团队管理页面',
    'Permission.tips1': 'View： 可查看云项目和本地项目',
    'Permission.tips2': 'Edit: 可上传数据、启动分析，并在云项目和本地项目中提交分析任务',
    'Permission.tips3': 'Delete: 可删除团队中的文件',
    'Permission.tips4': 'Download: 可下载团队中文件',
    'Remove.Group': '移除团队',
    'Remove.Btn': '移除',
    'Remove.Group.Tips1': '移除成员后，成员创建内容仍保留。',
    'Remove.Group.Tips2': '确认移除成员，请输入：',
    'Group.Data.Log': '日志',
    'Transfer.Group': '移交团队',
    'Transfer.Group.Btn': '移交',
    'Transfer.Group.Text1': '移交团队拥有者至',
    'Transfer.Group.Text2': '*仅显示团队内成员',
    'Transfer.Group.Text3': '操作不可撤销，请谨慎操作，是否继续？',
    'Transfer.Group.Text4': '请确认移交团队管理员给',
    'Merge.Group': '合并团队',
    'Merge.Group.Btn': '合并',
    'Merge.Group.Text1': '勾选需要合并的团队',
    'Merge.Group.Text2': '*仅显示有管理权限的团队',
    'Merge.Group.Text3': '请确认合并',
    'Merge.Group.Rule1': '合并规则',
    'Merge.Group.Rule2': '仅可合并有管理员权限的非个人团队',
    'Merge.Group.Rule3': '团队成员自动去重合并，保留当前权限',
    'Merge.Group.Rule4': '合并内容包括：云项目，本地项目，上传文件，结果文件和项目文件',
    'Move.Data.Text1': '移动数据至',
    'Move.Data.Text2': '团队',
    'Move.Data.Btn': '移动',
};

export const AccountInfoUS = {
    'Account.Menu.Account': 'My account',
    'Account.Menu.Renew.Subscription': 'Renew subscription',
    'Account.Menu.Security.Settings': 'Security settings',
    'Account.Menu.Email.Address': 'Change email address',
    'Account.Menu.Password': 'Change password',
    'Account.Menu.Login.log': 'Login log',
    'Account.Module.Username': 'Username',
    'Account.Module.First.Name': 'First name',
    'Account.Module.Last.Name': 'Last name',
    'Account.Module.Phone': 'Phone',
    'Account.Module.Institution.Name': 'Institution Name',
    'Account.Module.Account.Status': 'Account Status',
    'Account.Module.Subscribe.Or.Renew': 'Subscribe or Renew',
    'Account.Module.Current.Email': 'Current email',
    'Account.Module.New.Email': 'New email',
    'Account.Module.Authentication.Code': 'Authentication code',
    'Account.Module.Current.Password': 'Current password',
    'Account.Module.New.Password': 'New password',
    'Account.Module.Confirm.Password': 'Confirm password',
    'Account.Module.Last.Records': 'The last 10 records',
    'Account.Module.Subscription.Description': 'Subscription Description',
    'Account.Log.Time': 'Time',
    'Account.Log.Login.ip': 'Login ip',
    'Account.Log.Location': 'Location',
    'Account.Code': 'Get code',

    'Groups.Title':' Groups',
    "Group.Create": "Create New Group",
    "Group.Name": "Group Name",
    "Group.ID": "Group ID",
    "Group.Role": "Role",
    'Group.Create.Placeholder': 'Type in new group name',
    'Group.Limit': 'Seat',
    "Group.Settings": 'Group Settings',
    "Leave.Btn": 'Leave',
    'Group.Leave': 'Leave Group',
    'Group.Leave.Tips1': 'Please confirm leaving the group',
    'Group.Leave.Tips2': 'This action cannot be undone. Continue?',

    'Seat.Settings': 'Seat Settings',
    'Search.Group': 'Search Group',
    "Seat.Label": 'Seat (Used/Max)',
    'Group.Notes': 'Notes',
    'Group.Name.Length.Error': 'Group name cannot exceed 15 characters',
    'My.Space': 'My Space',
    'Seat.User': 'User',
    'Seat.Permission': 'Permission',
    'Seat.Invite.New.Member': 'Invite New Member',
    'Seat.Invite.Link': 'Invite with link',
    'Seat.Invite.Link.Btn': 'Copy link',
    'Seat.Invite.Valid.Link.Tips': 'Link is valid for 10 days and expires after a single use',
    'Seat.Invite.Link.Copy.Success': 'Invite link copied successfully',
    'Seat.Invite.Link.Copy.Failed': 'Failed to copy invite link, please try again',

    'Invite.Member.Tips1': "You've been Invited",
    'Invite.Member.Tips2': 'has invited you to join the',
    'Invite.Member.Tips3': "Once you join，you'll be able to",
    'Invite.Member.Tips4': 'shared projects based on your permissions.',
    'Invite.Member.Btn1':"Not now",
    'Invite.Member.Btn2':"Join group",

    "Invite.Successful.Header": "Successfully joined",
    "Invite.Successful.Content": "You have successfully joined the",
    "Invite.Successful.Content1": "team.",
    "Invite.Successful.Content2": "You can view the team from the project dropdown menu in the main menu.",
    'Space.Integrated.Datasets': 'Integrated Datasets',
    'Space.Uploaded.Files': 'Uploaded files',
    'Space.Custom.Datasets': 'Custom Datasets',
    'Space.Project.Files': 'Project Files',
    'Space.Other.Projects': 'Others(Owner)',
    'Space.Free': 'Free(Owner)',
    'Space.Total': 'Total',
    'Leave.Group.Tips': 'Group owner cannot leave the group',

    'Edit.Group.Tips': 'Group owner only',
    'Merge.Group.Tips': 'Group owner only',
    'Transfer.Group.Tips': 'Group owner only',

    'Leave.Seatting.Tips': 'Owner role cannot leave the group',
    'Leave.Tips': 'No permission',
    'Role.tips1': 'Owner: Has full permission to manage the group setting page',
    'Role.tips2': 'Admin: Has permission to manage the group setting page',
    'Role.tips3': 'Member: No permission to manage the group setting page',
    'Permission.tips1': 'View： Allows viewing results of integrated datasets and custom datasets',
    'Permission.tips2': 'Edit: Allows importing data, initiating analysis and submitting analysis tasks in integrated datasets and custom datasets',
    'Permission.tips3': 'Delete: Allows deletion of group files',
    'Permission.tips4': 'Download: Allows download of group files',
    'Remove.Group': 'Remove from group',
    'Remove.Btn': 'Remove',
    'Remove.Group.Tips1': 'The member’s created content will be retained after removal.',
    'Remove.Group.Tips2': 'To confirm the removal, please type: ',
    'Group.Data.Log': 'Log',

    'Transfer.Group': 'Transfer Group',
    'Transfer.Group.Btn': 'Transfer',
    'Transfer.Group.Text1': 'Transfer group owner to',
    'Transfer.Group.Text2': '*Only show group members',
    'Transfer.Group.Text3': 'This action cannot be undone. Continue?',
    'Transfer.Group.Text4': 'Please confirm transferring group admin to',

    'Merge.Group': 'Merge Group',
    'Merge.Group.Btn': 'Merge',
    'Merge.Group.Text1': 'Select the groups to merge',
    'Merge.Group.Text2': '*Only show groups with admin access',
    'Merge.Group.Text3': 'Please confirm merge groups',
    'Merge.Group.Rule1': 'Merge Rules',
    'Merge.Group.Rule2': 'Only non-personal groups with admin access can be merged.',
    'Merge.Group.Rule3': 'Group members will be deduplicated; current permissions will be retained.',
    'Merge.Group.Rule4': 'The following content will be merged: Integrated Datasets, Custom Datasets, Uploaded files, Result files and Project files.',
    'Move.Data.Text1': 'Move data to group',
    'Move.Data.Text2': 'Group',
    'Move.Data.Btn': 'Move',
};

